import transpt_qrlogo from '../assets/images/qrlogo.jpg';
import transpt_cover from '../assets/images/transpt.jpg';
import transpt_cover_black from '../assets/images/transpt.png';
import openRoad from '../assets/stickers/Open_Road_Certified._New.jpg';
import preauction from '../assets/stickers/as_is_preauction_ONYX.jpg';
import martinQR from '../assets/stickers/martin_QR.jpg';
import comingsoon from '../assets/logos/coming-soon.jpg';
import ap_logo_light from '../assets/logos/ap_logo_light.png';
import ap_logo_light_without_title from '../assets/logos/ap_logo_without_title.png';
import ap_logo_dark from '../assets/logos/ap_logo_dark.png';
import RapidRaconLogo from '../assets/images/RapidReconLogo.png';
import IpacketLogo from '../assets/images/ipacket.png';
import closeModel from '../assets/images/close.png';
import noBackground from '../assets/images/nobackground.png';
import notSet from '../assets/images/notset.png';
import reshootLogo from '../assets/logos/reshoot.png';
import dip_logo_light from '../assets/logos/dip_light.png';
import dip_logo_dark from '../assets/logos/dip_dark.png';
import notifyBellgif from '../assets/images/notify_bell.gif';
import tenorgif from '../assets/loaders/tenor.gif';
import dipPageSpinnerGIF from '../assets/loaders/spinner.gif';
import clockgif from '../assets/logos/step-loader.gif';
import qrdemo from '../assets/stickers/QRDemo.png';
import star from '../assets/images/star.png';
import newApStarFilled from '../assets/images/new_ap_star.png';
import group1 from '../assets/stickers/group1.jpg';

export const IMG_OPENROAD = openRoad;
export const IMG_OPENROADQR = openRoad;
export const IMG_PREAUCTION = preauction;
export const IMG_PREAUCTIONQR = preauction;
export const IMG_MARTINQR = martinQR;
export const IMG_COMINGSOON = comingsoon;
export const IMG_AP_LOGO_LIGHT = ap_logo_light;
export const IMG_AP_LOGO_LIGHT_WITHOUT_TITLE = ap_logo_light_without_title;
export const IMG_AP_LOGO_DARK = ap_logo_dark;
export const IMG_DIP_LOGO_LIGHT = dip_logo_light;
export const IMG_DIP_LOGO_DARK = dip_logo_dark;
export const IMG_RAPIDRACON_LOGO = RapidRaconLogo;
export const IMG_IPACKET_LOGO = IpacketLogo;
export const IMG_CLOSEMODEL = closeModel;
export const IMG_NOBACKGROUND = noBackground;
export const IMG_NOTSET = notSet;
export const IMG_RESHOOT_LOGO = reshootLogo;
export const IMG_TRANSPT_QRLOGO = transpt_qrlogo;
export const IMG_TRANSPT_COVER = transpt_cover;
export const IMG_TRANSPT_COVER_BLACK = transpt_cover_black;
export const IMG_GROUP1 = group1;

export const IMG_NOTIFYBELL_GIF = notifyBellgif;
export const IMG_TENOR_LOADER_GIF = tenorgif;
export const IMG_PAGESPINNER_GIF = dipPageSpinnerGIF;
export const IMG_CLOCK_GIF = clockgif;
export const IMG_QR_DEMO = qrdemo;
export const IMG_STAR = star;
export const NEW_IMG_STARFILLED = newApStarFilled;
